let axios = require('axios');
import router from './../router/router';
import routesNames from './../router/routesNames';
import store from "../store/store";
import mutations from "../store/mutations";
import {throttleAdapterEnhancer} from 'axios-extensions';

import pjson from '../../../package.json';

let getToken = function () {
    return store.state.token;
};

let getUrl = function() {
    let url = {
        base: "",
        api: "",
        img: ""
    };

    if(pjson.schema === "desa")
    {
        url.base = "http://ssbapi.local";
        url.api = "/v1.0/";
        url.img = "http://ws.sbi.local";
        return url;
    }

    url.base = "https://ws.smartsilobag.com";
    url.api = "/ssbapi/v1.0/";
    url.img = "https://ws.smartsilobag.com";
    return url;
};

let getBaseUrl = function()
{
    let url = getUrl();
    return url.base + url.api;
};

const axiosInstance = axios.create({
    baseURL: getBaseUrl(),
    timeout: 80000,
    adapter: (throttleAdapterEnhancer(axios.defaults.adapter, {threshold: 2 * 1000})),
    transformResponse: [function (strResponse) {
        let response = typeof strResponse === 'string' ? JSON.parse(strResponse) : strResponse;

        if (response.hasOwnProperty('code') && response.hasOwnProperty('descr') && response.code !== 0) {
            return response;
        }

        let error = undefined;
        if (response.error !== undefined && response.error instanceof Array) {
            error = response.error[0];
            if (error.code !== 0) {
                return error
            } else {
                return response;
            }
        }

        console.error("No se pudo tranformar correctamente la respuesta", response);
        return response;
    }]

});

// Add a response interceptor
axiosInstance.interceptors.response.use(response => {
    if (response.status === 200) {
        if (response.headers["x-api-key"] !== undefined) {
            if(pjson.schema === "desa") {
                console.debug("Actualizo el token", response.headers["x-api-key"]);
            }
            
            store.commit(mutations.UPDATE_TOKEN, response.headers["x-api-key"]);
        }
    }
    return response;

}, error => {
    if (error.response.status === 401 && error.response.config.url.indexOf('register') === -1) {
        alert("Su sesión a expirado");
        store.commit(mutations.UPDATE_TOKEN,undefined);
        router.push({name: routesNames.LOGIN});
    }
    return Promise.reject(error);
});

axiosInstance.interceptors.request.use(config => {
    config.headers["x-api-key"] = getToken() || "Sin Token";
    return config;
});



export default {
    login(userName, password) {
        const user = {user: userName, password: password};
        if(pjson.schema === "desa") {
            console.debug("Ejecuto el login", user);
        }
        
        return axiosInstance.post('/register', user).then(value => {
            if(pjson.schema === "desa") {
                console.debug("Login Exitoso", value);
            }
            return value.data;
        }).catch(reason => {
            throw reason.response.data
        })
    },
    logout(userId, token) {
        const logoutData = {user: userId, token: token};
        if(pjson.schema === "desa") {
            console.debug("Ejecuto el logout", logoutData);
        }
        return axiosInstance.post("/logout", logoutData).then(value => {
            return value.data
        }).catch(reason => {
            throw reason.response.data
        })
    },
    getSites() {
        return axiosInstance.get("/sites").then(value => {
            return value.data;
        }).catch(reason => {
            throw  reason.response.data;
        })
    },
    getSilos(siteId) {
        return axiosInstance.get("/silosbysite/" + siteId).then(value => {
            return value.data;
        }).catch(reason => {
            throw  reason.response.data;
        });

    },
    getSilo(siteId, siloId) {
        return axiosInstance.get("/silosdetail/" + siteId + "/" + siloId).then(value => {
            return value.data;
        }).catch(reason => {
            throw  reason.response.data;
        });
    },
    getGrainAlertThresholds(grain) {
        return axiosInstance.get("/limits/" + grain).then(value => {
            return value.data;
        }).catch(reason => {
            throw reason.response.data;
        })
    },
    updateGrainAlertThresholds(grainThresholds) {
        grainThresholds.token = getToken();
        return axiosInstance.post("/limits", grainThresholds).then(value => {
            return value.data
        }).catch(reason => {
            throw reason.response.data;
        })
    },
    getHistorics(siteId, siloId, section, from, to) {
        return axiosInstance.get("/history/" + siteId + "/" + siloId + "/" + section + "/" + from + "/" + to).then(value => {
            return value.data;
        }).catch(reason => {
            throw reason.response.data;
        })
    },
    getPromHistorics(siteId, siloId, from, to) {
        return axiosInstance.get("/promhistory/" + siteId + "/" + siloId + "/" + from + "/" + to).then(value => {
            return value.data;
        }).catch(reason => {
            throw reason.response.data;
        })
    },
    updateUser(user) {
        user.token = getToken();
        return axiosInstance.post('/updateuser', user).then(value => {
            return value.data;
        }).catch(reason => {
            throw reason.response.data;
        })
    },
    getEvents() {
        return axiosInstance.get('/events').then(value => {
            return value.data
        }).catch(reason => {
            throw reason.response.data;
        })
    },
    deleteEvent(eventId) {
        return axiosInstance.post('/events', {eventid: eventId, token: getToken()}).then(value => {
            return value.data
        }).catch(reason => {
            throw reason.response.data;
        })
    },
    getSectionRisk(siteId, siloId, sectionId, weeksInAdvance) {
        return axiosInstance.get('/risk/' + siteId + '/' + siloId + '/' + sectionId + '/' + weeksInAdvance).then(value => {
            return value.data
        }).catch(reason => {
            throw reason.response.data;
        })
    },
    getUrlImages()
    {
        let url = getUrl();
        return(url.img);
    },
    sendDataFormSeguro(data)
    {
        return axiosInstance.post('/seguro', { data }).then(value => {
            return value.data;
        }).catch(reason => {
            throw reason.response.data;
        })
    },
    getCotIndex(index,type)
    {
        return axiosInstance.post('/cotindex', { index: index,type: type }).then(value => {
            return value.data;
        }).catch(reason => {
            throw reason.response.data;
        })
    },
    sendClickSeguro(userid,event)
    {
        return axiosInstance.post('/clickseguro', { userid: userid, event: event }).then(value => {
            return value.data;
        }).catch(reason => {
            throw reason.response.data;
        })
    }
    
}
